import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

export function parseSurveyJson(value, fallback) {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === 'object') {
    return value;
  }

  if (typeof value !== 'string' || value.trim() === '') {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

function getSurveysApiBaseUrl() {
  return `${getConfig().LMS_BASE_URL}/moocit_admin_panel/api/surveys`;
}

export async function getCourseSurveys(courseId) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getSurveysApiBaseUrl()}/course-surveys-with-status/${encodeURIComponent(courseId)}/`,
  );
  return data;
}

export async function getSurvey(surveyId) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getSurveysApiBaseUrl()}/${surveyId}/`,
  );
  return data;
}

export async function getUserSurveyAnswers(courseId) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getSurveysApiBaseUrl()}/retrieve-user-survey-answers/${encodeURIComponent(courseId)}/`,
  );
  return data;
}

export async function submitSurveyAnswer(courseSurveyId, answers) {
  const { data } = await getAuthenticatedHttpClient().post(
    `${getSurveysApiBaseUrl()}/create-user-survey-answer/`,
    {
      course_survey: courseSurveyId,
      answers: JSON.stringify(answers),
    },
  );
  return data;
}
